'use strict';

var _require = require('redux'),
    createStore = _require.createStore;

var defaultCreateLocals = function defaultCreateLocals(_ref) {
  var params = _ref.params,
      store = _ref.store,
      query = _ref.query;
  return {
    state: store.getState(),
    dispatch: store.dispatch,
    params: params,
    query: query
  };
};

var defaultStore = function defaultStore() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createStore(function (state) {
    return state;
  }, state);
};

var ensureRoutes = function ensureRoutes(name) {
  throw new Error('No routes key was found on options passed to ' + name);
};

module.exports = {
  defaultCreateLocals: defaultCreateLocals,
  defaultStore: defaultStore,
  ensureRoutes: ensureRoutes
};


//////////////////
// WEBPACK FOOTER
// ../~/boiler-room-runner/dist/shared.js
// module id = 233
// module chunks = 0